import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { useState } from 'react';
import { useEffect } from 'react';
import useAccounts from '../../hooks/useAccounts';
import { useGetServiceProductOrCategoriesQuery } from '../../services/dashboardService';
import { FullPageWrapper } from '../custom/IndividualMappingLayout';
import amIVisible from '../../componentControl/registry';

export const IndividualServiceCategoryMapping = ({ formik }) => {

    const { t } = useTranslation()

    const [isLoadingAccounts, accountsList] = useAccounts('items');

    const { currentSw, serviceCategoriesLabels } = useSelector(state => state.dashboard)

    const { serviceCategory, isParentCategory } = formik.values;

    const [parentCategory, setCategory] = useState(isParentCategory);

    const [isCategoryChanged, setChanged] = useState(false);

    const isDynamicMapping = amIVisible("enter field for product and categories individual")

    const [isEmptyLabels, setIfEmptyLabels] = useState(false)

    const { isLoading, isFetching, refetch } = useGetServiceProductOrCategoriesQuery({
        recordItems: false,
        serviceItems: false,
        serviceCategory: true
    }, {
        refetchOnMountOrArgChange: false,
        selectFromResult: ({ data, ...rest }) => {
            let labels = data?.map((item) => {
                return {
                    label: item.name,
                    value: item.id
                }
            })

            labels = _.filter(labels, item => {
                return !_.keys(_.pickBy(serviceCategory, (items) => items !== '')).includes(item?.value + '')
            })

            return {
                data: labels,
                ...rest
            }
        }
    })

    useEffect(() => {
        setIfEmptyLabels(serviceCategoriesLabels?.length === 0)
    }, [serviceCategoriesLabels])

    useEffect(() => {
        if (serviceCategoriesLabels?.length === 0 && !isEmptyLabels) {
            refetch()
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceCategoriesLabels])

    useEffect(() => {
        if (isCategoryChanged) {
            setChanged(false)
            refetch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCategoryChanged])

    const refresh = (value) => {
        setCategory(value)
        setChanged(true)
    }

    return (
        <>
            <FullPageWrapper
                title={t('Map Service Categories')}
                fullPageDesp={t(`Individual Service categories can be mapped to unique accounts in ${currentSw}. All unassigned and new Service categories will be assigned to the default service category account.`, { swName: currentSw })}
                formik={formik}
                formikFieldName={"serviceCategoryMapping"}
                isLoading={isLoading || isFetching}
                isAccountsLoading={isLoadingAccounts}
                heading={"Service Categories"}
                parentCategory={parentCategory}
                isDynamicMapping={isDynamicMapping}
                options={accountsList}
                labelOption={serviceCategoriesLabels}
                refetch={refresh}
                advanceMapping
                rowLoaderProps={{
                    box: true,
                    rows: 10
                }}
            />
        </>
    )
}